export default function prevNextPaginationButtons(paginateButtons) {
    const prevButton = !!paginateButtons && paginateButtons?.prevButtonEl[0];
    const nextButton = !!paginateButtons && paginateButtons?.nextButtonEl[0];
    if (prevButton) {
       const prevLink = prevButton.querySelector('a');
        prevLink.setAttribute('rel', 'prev');
    }
    if (nextButton) {
        const nextLink = nextButton.querySelector('a');
        nextLink.setAttribute('rel', 'next');
    }
}
